import { render, staticRenderFns } from "./Special.vue?vue&type=template&id=64f6f6f1"
import script from "./Special.vue?vue&type=script&lang=js"
export * from "./Special.vue?vue&type=script&lang=js"
import style0 from "./Special.vue?vue&type=style&index=0&id=64f6f6f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports